"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollaborationActivityType = exports.NOTIFICATION_MESSAGE = void 0;
exports.NOTIFICATION_MESSAGE = {
    /*DocExplorerInit:"initDocExplorer",
    AllFodersInit:"AllFodersInit",
    UserInfoInit:"UserInfoInit",
    UserCredentialsInit:"UserCredentialsInit",*/
    RefreshDocExplorer: 'RefreshDocExplorer',
    RefreshDocExplorerOK: 'RefreshDocExplorerOK',
    NewVersion: 'newversion',
    Created: 'created',
    Moved: 'moved',
    Copy: 'copy',
    Deleted: 'deleted',
    AddShortcut: 'addshortcut',
    RemoveShortcut: 'removeshortcut',
    Rename: 'rename',
    NewStatus: 'newStatus',
    Locked: 'locked',
    Unlocked: 'unlocked',
    NewComments: 'newComments',
    RemoveComments: 'removeComments',
    SetAsCurrentVersion: 'setAsCurrentVersion',
    Convert2PDF: 'convert2PDF',
    Revert2PPT: 'revert2PPT',
    Shared2Collaborators: 'Shared2Collaborators',
    Unshared2Collaborators: 'Unshared2Collaborators',
    CollaboratorRoleUpdated: 'CollaboratorRoleUpdated',
    ReceiveRefreshFolderMessage: 'ReceiveRefreshFolderMessage',
    ReceiveInstanceName: 'ReceiveInstanceName',
    ReceiveGenerationSucceededResult: 'ReceiveGenerationSucceededResult',
    ReceiveGenerationFailedResult: 'ReceiveGenerationFailedResult',
    StoryPublished: 'StoryPublished',
    NewNote: 'newNote',
};
exports.CollaborationActivityType = {
    InviteCollaborationUser: 201,
    QuitCollaboration: 202,
    UpdateCollaborationInfo: 203,
    LeaveNotes: 301,
    CreateFolder: 400,
    CopyFolder: 401,
    MoveFolder: 402,
    DeleteFolder: 403,
    UpdateFolder: 404,
    RenameFolder: 405,
    DownloadFolder: 406,
    MoveFolderFromFolder: 407,
    CreateDocument: 500,
    CopyDocument: 501,
    MoveDocument: 502,
    DeleteDocument: 503,
    UpdateDocument: 504,
    RenameDocument: 505,
    DownloadDocument: 506,
    LockDocument: 507,
    UnlockDocument: 508,
    MoveDocumentFromFolder: 509,
    CreateFreestyleInstance: 510,
    GenerateDocument: 601,
    RecorderDocument: 602,
    ConvertDocument: 603,
    RevertDocument: 604,
    DeliveryDocument: 701,
};
//# sourceMappingURL=NotificationMessages.js.map